import { Spinner } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

// NOTE: Add relative class to the parent component!
export function KalenderLoading() {
  const { t } = useTranslation();
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center rounded-md bg-white/75">
      <Spinner size="lg" variant="dark-grey">
        {t('actions.loading')}
      </Spinner>
    </div>
  );
}
